import styled from 'styled-components'

import type { StyledCssProps } from '@subaio/components'

import { inputStyles } from '../Shared'

export const InputContainer = styled.div<StyledCssProps<typeof inputStyles>>`
	${inputStyles}
`
